import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolaturcabs() {



  const cardData =
  {
    keyword: 'Pune to Latur Cabs',
    heading: 'Sai Trupti Cabs: Pune to Latur Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Latur cab services, designed to make your long-distance journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Latur. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Latur convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Latur with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ganj Golai Market",
    "description": "Ganj Golai in Latur is the vibrant heart of the city — a circular market junction where nearly 19 roads converge, anchored by a historic two-storey structure built in 1917. :contentReference[oaicite:1]{index=1} Stalls and shops sell everything from gold ornaments and footwear to jaggery, chillies and local handicrafts. Walking through the crowd you feel the energy of a trading hub that has served generations. Evening lights and local eats add a lively flavour as the busy afternoon shifts into dusk. Ganj Golai is more than a market — it’s the pulse of Latur’s commerce and community gathering."
  },
  {
    "title": "Siddheshwar & Ratneshwar Temple",
    "description": "The Siddheshwar & Ratneshwar Temple, located just 2 km from Latur city centre, is a significant spiritual landmark dedicated to the 12th-century saint Siddharameshwar. :contentReference[oaicite:2]{index=2} With intricate stone carvings and mythological motifs, the temple architecture invites both faith and admiration. During Mahashivratri the fair draws devotees from across the region, the air filled with chants and incense. Surrounded by calm grounds and shaded courtyards, the temple offers a moment of quiet reflection amid the district’s bustle. It stands as a bridge between Latur’s historical devotion and living tradition."
  },
  {
    "title": "Kharosa Caves",
    "description": "Tucked away about 45 km from Latur city, the Kharosa Caves are a fascinating group of rock-cut caves dating back to the 6th century, featuring sculpted panels of Buddha, Narsimha, Shiva-Parvati and other mythic scenes. :contentReference[oaicite:3]{index=3} Set in a quiet village context and carved into basalt rock, the caves combine spirituality, history and nature seamlessly. A visit involves gentle trekking and exploration of ancient halls, with the serenity of countryside all around. For travelers seeking something off-beat, Kharosa offers a poetic fusion of art and landscape."
  },
  {
    "title": "Udgir Fort",
    "description": "Udgir Fort, located in Udgir Taluka of Latur district, is a majestic hill-fort that dates to pre-Bahamani age and later featured in Maratha-Nizam conflicts. :contentReference[oaicite:4]{index=4} Climbing its stone ramparts gives panoramic views of the surrounding plateau and historic battlefields. The fort’s gateway, ruins and vantage points are ideal for history enthusiasts and photographers. On clear mornings the hills glow with golden light, and the fort’s silence offers a contrast with the city’s rhythm. Udgir Fort reflects Latur’s legacy of strategic strength and bygone eras."
  },
  {
    "title": "Ausa Fort",
    "description": "Ausa Fort, set in Ausa town within Latur district, is a lesser-known gem quietly preserving its medieval character. :contentReference[oaicite:5]{index=5} The fort, surrounded by low hills and open plains, invites a slower, introspective visit — walk the bastions, imagine the old sentries, and take in the sweeping vista of the region. Its quiet charm and accessibility make it ideal for a half-day excursion from Latur city. The journey through village roads and open countryside adds to the sense of discovery."
  },
  {
    "title": "Nana Nani Park (Vilasrao Deshmukh Park)",
    "description": "Nana Nani Park, also known as Vilasrao Deshmukh Park, is a cherished green space in Latur city where families come for leisure, children’s play and evening strolls. :contentReference[oaicite:6]{index=6} The well-laid lawns, walking paths and open air theatre create a pleasant urban contrast to the surrounding semi-arid landscape. At dusk the park takes on a calm mood as the city lights begin to glow and the breeze cools. It’s a perfect spot for relaxed downtime after exploring the historic or spiritual sites of Latur."
  },
  {
    "title": "Shri Ashtavinayak Mandir",
    "description": "Located in Shivaji Nagar, Latur, the Shri Ashtavinayak Mandir draws devotees and seekers alike — the temple boasts eight different forms of Lord Ganesha along its walls, with a central 4-ft marble Ganesha idol and gardens flanking the complex. :contentReference[oaicite:7]{index=7} Its South-Indian style architecture amid the Marathwada setting gives it a unique feel. Visitors meditate, take blessings, and stroll the fountain-laced gardens as the city hums beyond the temple gates. It blends spiritual calm with community warmth, making it a must in Latur’s list."
  },
  {
    "title": "Virat Hanuman Mandir",
    "description": "The Virat Hanuman Mandir in Latur is a vibrant temple dedicated to Lord Hanuman, popular for its energy and large size. :contentReference[oaicite:8]{index=8} Devotees arrive in the early morning to attend aarti, offer prasad, and walk the sacred grounds. The temple’s towering presence and devotion-filled ambiance make it a place not only of faith but of collective expression. With choruses of bhajans, the Hammer of the god echoes symbolic strength. The surrounding marketplace and eateries add to the local experience."
  },
  {
    "title": "Surat Shawali Dargah",
    "description": "Surat Shawali Dargah is a revered Sufi shrine in Latur district that draws devotees of many faiths and reflects the region’s communal harmony. :contentReference[oaicite:9]{index=9} Its white-washed dome, shaded courtyards and rhythmic chanting create a peaceful haven amid daily life. Evening light, qawwalis, and the gentle hum of prasad as visitors share food lend the place a spiritual softness. The dargah represents Latur’s inclusive spirit — where tradition, devotion and humanity meet."
  },
  {
    "title": "Mehrun Lake",
    "description": "Mehrun Lake, situated within Latur city, is a serene water-body surrounded by promenades and trees, offering a peaceful retreat in the heart of town. :contentReference[oaicite:10]{index=10} Evening boat rides, local snacks by the lakeside and the cool breeze make it a favourite for families and couples. As the sun sets, reflections ripple on the water and city lights spark on the shoreline. Mehrun Lake gives a restful moment of nature in Latur’s urban setting."
  }
],



"services": [
  {
    "name": "Pune to Latur Cabs",
    "description": "Book comfortable Pune to Latur cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Latur Taxi Service",
    "description": "Hire a Pune to Latur taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Latur Car Hire",
    "description": "Rent a car from Pune to Latur for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Latur",
    "description": "Travel comfortably with AC cab service from Pune to Latur. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Latur",
    "description": "Affordable non-AC cab service from Pune to Latur for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Latur",
    "description": "Book spacious and comfortable Innova cabs from Pune to Latur. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Latur",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Latur. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Latur",
    "description": "Travel in style with luxury cab services from Pune to Latur. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Latur",
    "description": "Get pocket-friendly Pune to Latur cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Latur Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Latur ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Latur One Way Cab",
    "description": "Book one-way cabs from Pune to Latur at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Latur without return plans."
  },
  {
    "name": "Pune to Latur Drop Cab",
    "description": "One-way drop cab service from Pune to Latur with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Latur",
    "description": "Premium corporate cab hire from Pune to Latur with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Latur",
    "description": "Elegant wedding cab service from Pune to Latur with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Latur",
    "description": "Book your Pune to Latur cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Latur Cabs", "Pune to Latur Taxi Service"],
  ["Pune to Latur Car Hire", "AC Cab Pune to Latur"],
  ["Non AC Cab Pune to Latur", "Innova Cab Pune to Latur"],
  ["Ertiga Cab Pune to Latur", "Luxury Cab Pune to Latur"],
  ["Affordable Cab Pune to Latur", "Pune to Latur Outstation Cab"],
  ["Pune to Latur One Way Cab", "Pune to Latur Drop Cab"],
  ["Online Cab Booking Pune to Latur", "Corporate Cab Pune to Latur"],
  ["Wedding Cab Pune to Latur", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Latur Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers safe and comfortable cab services from Pune to Latur — perfect for family travel, business trips, and leisure journeys across Maharashtra."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and transparent fares for Pune to Latur cabs — no hidden charges, no surge pricing, and complete value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars based on your comfort, group size, and budget for the Pune–Latur route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled and courteous drivers are familiar with the Pune to Latur route, ensuring a safe, smooth, and punctual journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from anywhere in Pune — airport, home, office, or railway station — and drop-offs at your desired location in Latur."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs ensures a fleet of clean, sanitized, and regularly serviced vehicles for a comfortable and reliable travel experience every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with booking, fare details, or route information for your Pune to Latur cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Latur cab easily via call, WhatsApp, or our website — receive instant confirmation and timely service without any hassle."
  }
]




























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Latur cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Latur cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Latur cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Latur cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Latur?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Latur routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Latur route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Latur?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Latur for attractions like Siddheshwar Temple, Udgir Fort, and Narsinha Mandir.',
  },
  {
    question: 'Is the Pune to Latur cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Latur cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Latur cab fares?',
    answer: 'Our Pune to Latur cab fares start from ₹3,500 for sedans and ₹4,200–₹5,200 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Latur cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Latur cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Latur cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Latur trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kiran More',
    feedback: 'Our Pune to Latur trip with Sai Trupti Cabs was very comfortable and hassle-free. The driver was punctual and the ride was smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Aarti Desai',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Latur journey. Clean cars, safe driving, and professional staff made our trip memorable.',
    rating: 5,
  },
];



























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Latur Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-latur-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Latur cab service with one way taxi, round trip cabs, Innova Crysta, Ertiga, sedan and SUV options. Book affordable long distance outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Latur"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7240"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-latur-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};








  return (
    <div>

<Helmet>
  <title>Pune to Latur Cab Service | One Way Taxi ₹5999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Latur cab at best price ₹5999 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, reliable and 24x7 cab service for long distance travel." 
  />

  <meta 
    name="keywords" 
    content="pune to latur cab, pune to latur taxi, pune to latur cab service, pune to latur one way cab, pune to latur taxi fare, pune to latur innova crysta, pune to latur ertiga cab, pune to latur sedan cab, cheap pune to latur cab, best cab service pune to latur, pune to latur drop taxi, pune to latur round trip cab, outstation cab pune to latur, pune to latur online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolaturcabs;